import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_component_BaseButton, {
    label: "Add",
    color: "dark-gray",
    "background-color": "slightly-dark-white",
    icon: "plus",
    "icon-padding-bottom": 1,
    "icon-size": 15,
    "border-color": "gray",
    "border-radius": 13,
    width: 80,
    height: 26,
    "padding-horizontal": 12,
    "font-size": 13,
    enabled: _ctx.enabled,
    "on-click": _ctx.onClick
  }, null, 8, ["enabled", "on-click"]))
}